import T from "./_DataView.js";
import j from "./_Map.js";
import M from "./_Promise.js";
import _ from "./_Set.js";
import v from "./_WeakMap.js";
import C from "./_baseGetTag.js";
import d from "./_toSource.js";
var t = T, a = j, o = M, i = _, n = v, b = C, e = d, g = "[object Map]", k = "[object Object]", f = "[object Promise]", u = "[object Set]", w = "[object WeakMap]", S = "[object DataView]", V = e(t), D = e(a), P = e(o), W = e(i), l = e(n), r = b;
(t && r(new t(new ArrayBuffer(1))) != S || a && r(new a()) != g || o && r(o.resolve()) != f || i && r(new i()) != u || n && r(new n()) != w) && (r = function(m) {
  var c = b(m), p = c == k ? m.constructor : void 0, s = p ? e(p) : "";
  if (s)
    switch (s) {
      case V:
        return S;
      case D:
        return g;
      case P:
        return f;
      case W:
        return u;
      case l:
        return w;
    }
  return c;
});
var $ = r;
export {
  $ as default
};
//# sourceMappingURL=_getTag.js.map
